// Scoring constants
const BOOT_MAX = 2 // ±2 Mondo sizes
const WEIGHT_MAX = 25 // ±25 lbs
const BOOT_SIZE_CONSIDERATION = 0.6 // Boot size taken 60% into consideration
const WEIGHT_CONSIDERATION = 0.4 // Weight taken 40% into consideration
const MAX_RESULTS = 2

// Boot size conversion
const BOOT_SIZES = [
  { mondo: 24.0, us: "US 6K / Men's US 6 / Women's US 7", euro: 38, uk: 5 },
  {
    mondo: 24.5,
    us: "US 6.5K / Men's US 6.5 / Women's US 7.5",
    euro: 39,
    uk: 5.5,
  },
  { mondo: 25.0, us: "US 7K / Men's US 7 / Women's US 8", euro: 40, uk: 6 },
  { mondo: 25.5, us: "Men's US 7.5 / Women's US 8.5", euro: 40.5, uk: 6.5 },
  { mondo: 26.0, us: "Men's US 8 / Women's US 9", euro: 41, uk: 7 },
  { mondo: 26.5, us: "Men's US 8.5 / Women's US 9.5", euro: 41.5, uk: 7.5 },
  { mondo: 27.0, us: "Men's US 9 / Women's US 10", euro: 42, uk: 8 },
  { mondo: 27.5, us: "Men's US 9.5 / Women's US 10.5", euro: 42.5, uk: 8.5 },
  { mondo: 28.0, us: "Men's US 10 / Women's US 11", euro: 43, uk: 9 },
  { mondo: 28.5, us: "Men's US 10.5", euro: 43.5, uk: 9.5 },
  { mondo: 29.0, us: "Men's US 11", euro: 44, uk: 10 },
  { mondo: 29.5, us: "Men's US 11.5", euro: 44.5, uk: 10.5 },
  { mondo: 30.0, us: "Men's US 12", euro: 45, uk: 11 },
  { mondo: 31.0, us: "Men's US 13", euro: 46, uk: 12 },
  { mondo: 32.0, us: "Men's US 14", euro: 47, uk: 13 },
  { mondo: 33.0, us: "Men's US 15", euro: 48, uk: 14 },
]

const BOOT_SIZES_KIDS = [
  { mondo: 12.5, us: 'US 6C', euro: 23, uk: 5 },
  { mondo: 13.5, us: 'US 7C', euro: 24, uk: 6 },
  { mondo: 14.5, us: 'US 8C', euro: 25, uk: 7 },
  { mondo: 15.5, us: 'US 9C', euro: 26, uk: 8 },
  { mondo: 16.5, us: 'US 10C', euro: 27, uk: 9 },
  { mondo: 17.5, us: 'US 11C', euro: 28, uk: 10 },
  { mondo: 18.5, us: 'US 12C', euro: 29, uk: 11 },
  { mondo: 19.5, us: 'US 13C', euro: 30.5, uk: 12 },
  { mondo: 20.0, us: 'US 1K', euro: 31.5, uk: 13 },
  { mondo: 20.5, us: 'US 2K', euro: 33, uk: 1 },
  { mondo: 21.0, us: "US 3K / Women's US 4", euro: 34, uk: 2 },
  { mondo: 22.0, us: "US 4K / Women's US 5", euro: 35, uk: 3 },
  { mondo: 23.0, us: "US 5K / Women's US 6", euro: 36.5, uk: 4 },
  { mondo: 24.0, us: "US 6K / Men's US 6 / Women's US 7", euro: 38, uk: 5 },
  { mondo: 25.0, us: "US 7K / Men's US 7 / Women's US 8", euro: 40, uk: 6 },
  { mondo: 25.5, us: "Men's US 7.5 / Women's US 8.5", euro: 40.5, uk: 6.5 },
  { mondo: 26.0, us: "Men's US 8 / Women's US 9", euro: 41, uk: 7 },
  { mondo: 26.5, us: "Men's US 8.5 / Women's US 9.5", euro: 41.5, uk: 7.5 },
]

// Confidence score
function confidenceScore (
  customerBoot,
  customerWeight,
  optimalBoot,
  optimalWeight,
) {
  const bootDiff = Math.abs(customerBoot - optimalBoot)
  const weightDiff = Math.abs(customerWeight - optimalWeight)
  if (bootDiff > BOOT_MAX || weightDiff > WEIGHT_MAX) return null
  const bootScore = (1 - bootDiff / BOOT_MAX) * 100
  const weightScore = (1 - weightDiff / WEIGHT_MAX) * 100
  return (
    bootScore * BOOT_SIZE_CONSIDERATION + weightScore * WEIGHT_CONSIDERATION
  )
}

function recommendSizes (customerBootMondo, customerWeightLbs, sizes) {
  return sizes
    .filter((s) => s.optimalBoot != null && s.optimalWeight != null)
    .map((s) => ({
      ...s,
      score: confidenceScore(
        customerBootMondo,
        customerWeightLbs,
        s.optimalBoot,
        s.optimalWeight,
      ),
    }))
    .filter((s) => s.score !== null)
    .sort((a, b) => b.score - a.score)
    .slice(0, MAX_RESULTS)
}

// Conversions
function toMondo (value) {
  return parseFloat(value)
}

function toLbs (value, unit) {
  return unit === 'kg' ? value * 2.20462 : parseFloat(value)
}

// Parse product data
function getProductData () {
  const el = document.getElementById('product-json')
  if (!el) return null

  try {
    const data = JSON.parse(el.textContent)

    const colorIndex = data.colorOptionIndex

    const allVariants = (data.variants || []).map((v) => {
      const size = v.options
        ? v.options.find((opt, i) => i !== colorIndex)
        : null

      return {
        id: v.id,
        color: v.color,
        size,
        optimalBoot:
          v.optimal_boot_size != null ? parseFloat(v.optimal_boot_size) : null,
        optimalWeight:
          v.optimal_weight != null ? parseFloat(v.optimal_weight) : null,
      }
    })

    const sizes = (data.variants || [])
      .filter((v) => v.optimal_boot_size != null && v.optimal_weight != null)
      .map((v) => {
        const size = v.options
          ? v.options.find((opt, i) => i !== colorIndex)
          : null

        return {
          variantId: v.id,
          title: v.title,
          size,
          color: v.color,
          optimalBoot: parseFloat(v.optimal_boot_size),
          optimalWeight: parseFloat(v.optimal_weight),
          available: v.available,
          price: v.price,
          comparePrice: v.compare_at_price,
        }
      })

    return { allVariants, sizes }
  } catch (e) {
    console.error('Size finder - Failed to parse product JSON', e)
    return null
  }
}

class SizeFinder extends window.BAO.CustomElement() {
  connectedCallback () {
    // Fix for custom elements in drawers using data-module-drawers-move-me="root"
    if (this.hasBeenInitialised) {
      this.listeners.removeAll()
      this.setupListeners()
      return
    }

    super.connectedCallback()

    this.productData = getProductData()
    this.selectedVariantId = null
    this.results = []

    if (window.location.hash === '#size-finder') {
      setTimeout(() => {
        window.drawers.activeDrawerKey = 'size-finder'
      }, 200)
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'change', this.onChange.bind(this))
    this.listeners.add(this, 'click', this.onClick.bind(this))

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.DRAWER.CLOSE,
      this.clearResults.bind(this),
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PRODUCT.OPTION_SELECTED,
      () => {
        setTimeout(() => {
          this.filterSizeOptions()
        }, 100)
      },
    )
  }

  onChange (e) {
    if (e.target.closest(this.els?.bootSystem?.selector)) {
      this.onBootSystemChange(e)
    }
  }

  onClick (e) {
    if (e.target.closest(this.els?.weightUnitBtn?.selector)) {
      this.onWeightUnitToggle(e)
      return
    }
    if (e.target.closest(this.els?.submit?.selector)) {
      this.onSubmit()
      return
    }
    if (e.target.closest(this.els?.reset?.selector)) {
      this.clearResults()
    }
  }

  onBootSystemChange (e) {
    const system = e.target.value
    const sizeSelect = this.els.bootSize.element

    sizeSelect.innerHTML = this.buildBootOptions(system)
    sizeSelect.value = ''

    this.clearResults()
  }

  onWeightUnitToggle () {
    const newUnit = this.weightUnit === 'kg' ? 'lbs' : 'kg'
    const input = this.els.weightInput.element

    // Convert existing value
    if (input && input.value) {
      const val = parseFloat(input.value)
      if (!isNaN(val)) {
        input.value =
          newUnit === 'kg'
            ? Math.round(val / 2.20462)
            : Math.round(val * 2.20462)
      }
    }

    if (input) {
      input.placeholder =
        newUnit === 'kg'
          ? input.dataset.placeholderKg
          : input.dataset.placeholderLbs
    }

    this.weightUnit = newUnit
    this.clearResults()
  }

  onSubmit () {
    this.clearError()

    const bootSizeEl = this.els.bootSize.element
    const weightEl = this.els.weightInput.element

    const boot = bootSizeEl?.value
    const weight = weightEl?.value
    const unit = this.weightUnit

    if (!boot) {
      this.showError(this.dataset.errorBoot || '')
      return
    }
    if (!weight || isNaN(parseFloat(weight)) || parseFloat(weight) <= 0) {
      this.showError(this.dataset.errorWeight || '')
      return
    }

    const bootMondo = toMondo(boot)
    const weightLbs = toLbs(parseFloat(weight), unit)

    // Filter to current colour only — find the selected variant ID from the
    // product form hidden input, look up its colour, then restrict scoring to
    // variants sharing that colour.
    const currentVariantId = document.querySelector('input[name="id"]')?.value
    const currentColor = this.productData.allVariants.find(
      (v) => String(v.id) === String(currentVariantId),
    )?.color
    const sizesForColor = currentColor
      ? this.productData.sizes.filter((s) => s.color === currentColor)
      : this.productData.sizes

    this.results = recommendSizes(bootMondo, weightLbs, sizesForColor)
    const bestAvailable = this.results.find((r) => r.available)

    this.selectedVariantId = bestAvailable
      ? String(bestAvailable.variantId)
      : this.results[0]
        ? String(this.results[0].variantId)
        : null

    this.renderResults()
  }

  // Render results
  async renderResults () {
    const area = this.els.resultsArea.element
    if (!area) return

    area.innerHTML =
      this.results.length === 0 ? this.noResultsHTML() : this.resultsHTML()
    area.hidden = false

    const form = this.els.form.element
    form.hidden = true

    // Render product form via section renderer
    if (this.results.length > 0) {
      const productUrl = window.location.pathname
      const variantParam = this.selectedVariantId
        ? `?variant=${this.selectedVariantId}`
        : ''

      await window.BAO.sectionRenderer
        .fetchSingle('size-finder-results', `${productUrl}${variantParam}`)
        .then((res) => {
          const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
          const bodyContent = newDOM.querySelector('.drw-SizeFinderResults')

          const existing = area.querySelector('.drw-SizeFinderResults')
          if (existing) existing.remove()

          area.insertAdjacentHTML('beforeend', bodyContent.outerHTML)

          this.observeQuickView()

          requestAnimationFrame(() => {
            this.filterSizeOptions()
          })
        })
        .catch(() => {})
    }

    area.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }

  observeQuickView () {
    const area = this.els.resultsArea.element
    const quickView = area?.querySelector('.drw-SizeFinderResults')
    if (!quickView) return

    if (this.observer) this.observer.disconnect()

    this.observer = new MutationObserver(() => {
      this.filterSizeOptions()
    })

    this.observer.observe(quickView, {
      childList: true,
      subtree: true,
    })
  }

  filterSizeOptions (retry = 0) {
    if (!this.results.length) return

    const area = this.els.resultsArea.element
    if (!area) return

    const quickView = area.querySelector('.drw-SizeFinderResults')

    // Retry if not rendered yet
    if (!quickView) {
      if (retry < 5) {
        setTimeout(() => this.filterSizeOptions(retry + 1), 50)
      }
      return
    }

    const options = quickView.querySelectorAll(
      '[data-product-options-el="option"]',
    )

    // Retry if options not ready yet
    if (!options.length) {
      if (retry < 5) {
        setTimeout(() => this.filterSizeOptions(retry + 1), 50)
      }
      return
    }

    const recommendedIds = new Set(
      this.results.map((r) => Number(r.variantId)),
    )

    options.forEach((option) => {
      const input = option.querySelector('[data-variant-id]')
      if (!input) return

      const id = Number(input.dataset.variantId)
      if (!id) return

      option.hidden = !recommendedIds.has(id)
    })
  }

  resultsHTML () {
    const plural = this.results.length > 1
    const allSoldOut = this.results.every((r) => !r.available)
    const singleSoldOut = !plural && allSoldOut
    const names = this.results
      .map((r) => r.size)
      .join(` ${this.dataset.orLabel || ''} `)

    let title, text

    if (plural && allSoldOut) {
      title = (this.dataset.titleMultipleSoldOut || '').replace(
        '{sizes}',
        names,
      )
      text = (this.dataset.textMultipleSoldOut || '').replace('{sizes}', names)
    } else if (singleSoldOut) {
      title = (this.dataset.titleSingleSoldOut || '').replace(
        '{size}',
        this.results[0].size,
      )
      text = (this.dataset.textSingleSoldOut || '').replace(
        '{size}',
        this.results[0].size,
      )
    } else if (plural) {
      title = (this.dataset.titleMultiple || '').replace('{sizes}', names)
      text = (this.dataset.textMultiple || '').replace('{sizes}', names)
    } else {
      title = (this.dataset.titleSingle || '').replace(
        '{size}',
        this.results[0].size,
      )
      text = (this.dataset.textSingle || '').replace(
        '{size}',
        this.results[0].size,
      )
    }

    return `
      <p class="drw-SizeFinder_Title fz-20_130">${title}</p>
      <p class="drw-SizeFinder_Text fz-14_140 rte-RichText">${text}</p>
    `
  }

  noResultsHTML () {
    const title = this.dataset.titleNoResults || ''
    const text = this.dataset.textNoResults || ''
    const resetLabel = this.dataset.resetLabel || ''

    return `
      <p class="drw-SizeFinder_Title fz-20_130">${title}</p>
      <p class="drw-SizeFinder_Text fz-14_140 rte-RichText">${text}</p>

      <div class="drw-SizeFinder_Buttons">
        <a href="/" class="drw-SizeFinder_Button btn-Button btn-Button-black btn-Button-border">
          See All Snowboards
        </a>

        <button type="button" class="drw-SizeFinder_Reset btn-Text fz-12_150" data-size-finder-el="reset">
          ${resetLabel}
        </button>
      </div>    
    `
  }

  buildBootOptions (system) {
    const placeholder = `<option value="">${this.bootSystemLabel(system)}</option>`
    const bootSizes = this.bootSizes

    return (
      placeholder +
      bootSizes
        .map((b) => {
          const value = b.mondo
          const label =
            system === 'mondo' ? this.formatMondo(b.mondo) : b[system]

          return `<option value="${value}">${label}</option>`
        })
        .join('')
    )
  }

  formatMondo (value) {
    return value % 1 === 0 ? `${value}` : `${value}`
  }

  bootSystemLabel (system) {
    const labels = {
      us: this.dataset.labelUs || '',
      euro: this.dataset.labelEuro || '',
      uk: this.dataset.labelUk || '',
      mondo: this.dataset.labelMondo || '',
    }
    return labels[system] || ''
  }

  get bootSizes () {
    return this.dataset.isKidsProduct === 'true' ? BOOT_SIZES_KIDS : BOOT_SIZES
  }

  get weightUnit () {
    return this.getAttribute('weight-unit') || 'kg'
  }

  set weightUnit (value) {
    this.setAttribute('weight-unit', value)
  }

  clearResults () {
    const area = this.els.resultsArea.element
    if (!area) return
    area.innerHTML = ''
    area.hidden = true

    const form = this.els.form.element
    form.hidden = false

    this.selectedVariantId = null
    this.results = []
    this.clearError()
  }

  showError (msg) {
    const el = this.els.error?.element
    if (!el) return
    el.textContent = msg
    el.hidden = false
  }

  clearError () {
    const el = this.els.error?.element
    if (!el) return
    el.textContent = ''
    el.hidden = true
  }
}

if (!customElements.get('size-finder')) {
  customElements.define('size-finder', SizeFinder)
}
